
const Roles = ['Wybierz', 'Monter', 'Spawacz','CNC', 'Ślusarz', 'Szlifierz', 'Kowal', 'Malarz', 'Brygadzista', 'Inżynier']

export default Roles
